
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/about-us/csr-partnerships",
      function () {
        return require("private-next-pages/us/about-us/csr-partnerships/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/about-us/csr-partnerships"])
      });
    }
  